<template>
  <div id="app" >

  <div v-if="showAlertModal" class="modal-overlay" @click.self="closeAlertModal">
    <div class="modal-box">
      <div class="modal-icon">
        <i class="fas fa-exclamation-circle"></i>
      </div>
      <p class="modal-message">{{ alertMessage }}</p>
      <button class="modal-button" @click="closeAlertModal">Entendi</button>
    </div>
  </div>

  <div class="main-content">
    <div class="logo-container">
      <a href="https://memorialparquemaceio.com.br">
      <img src="./assets/logo.svg" alt="Logo" style="width:250px"/>
      </a>
    </div>
    <br/>
    <div class="search-container">
      <input
        class="search-input"
        type="text"
        placeholder="Nome do Sepultado"
        v-model="search_name"
      />
      <div class="search-icon" @click="search">
        <!-- You can use an SVG icon here or an image with a search icon -->
        <!-- For example, using an SVG icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="white"
          width="32px"
          height="32px"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l4 3.85 1.5-1.5-3.85-4zm-5 0a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"
          />
        </svg>
      </div>
    </div>

    <div v-if="loading" class="loading-indicator">

      <img src="./assets/loading.gif" alt="Carregando..." />


    </div>

    <div class="card-container">
      <div v-if="cardRows && cardRows.length">
        <CardItem
          v-for="card in cardRows"
          :key="card.id"
          :nome="card.falecido"
          :falecimento="card.falecimento"
          :sepultamento="card.sepultamento"
          :quadra="card.quadra"
          :letra="card.letra"
          :jazigo="card.jazigo"
          :cardColor="cardColor"
        />
      </div>
      <div v-else>
       <span v-if="loading == false"> Não encontrado óbitos </span>
      </div>
      

    </div>

    
         <!-- Controles de paginação -->
         <div v-if="totalPages > 1" class="pagination">
          <button
            class="pagination-button"
            @click="goToPage(currentPage - 1)"
            :disabled="currentPage === 1"
          >
            <i class="fas fa-chevron-left"></i> <!-- Ícone de seta para a esquerda -->
          </button>
          <span class="pagination-text"> Página {{ currentPage }} de {{ totalPages }}</span>
          <button
            class="pagination-button"
            @click="goToPage(currentPage + 1)"
            :disabled="currentPage === totalPages"
          >
            <i class="fas fa-chevron-right"></i> <!-- Ícone de seta para a direita -->
          </button>
        </div>
        <br/>
  </div>

    <footer class="footer">
      <div class="footer-content">
        <img src="./assets/LOGOSVG4.svg" alt="Grupo Parque das Flores" style="width: 84px; height: 64px;">
        <p style="color: white; text-align: center;">©2026 Empresa do Grupo Parque -
          Todos os direitos reservados <br/>
        </p>
      </div>
    </footer>


  </div>
</template>

<script>
import CardItem from './components/CardItem.vue'
import Contrato from './services/contrato'

export default {
  name: 'App',
  components: {
    CardItem
  },

  data() {
    return {
      cardColor: "darkgreen",
      loading: false,
      currentPage: 1,
      totalPages:1,
      pageSize: 20,
      cardRows: [
  
      ],
      search_name: '',
      showAlertModal: false,
      alertMessage: '',
    };
  },

  mounted() {
   
  },

  methods:{

    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.search();
      }
    },

    showAlert(message) {
      this.alertMessage = message;
      this.showAlertModal = true;
    },

    closeAlertModal() {
      this.showAlertModal = false;
    },


    search(){



      
      if(this.search_name.length < 5){
        this.showAlert('Por favor, o campo de busca requer no mínimo 5 caracteres.');
        return 
      }

      this.cardRows = [];
      this.loading = true; 

      Contrato.lista(this.search_name, "MEMORIAL PARQUE MACEIO", this.currentPage, this.pageSize)
              .then(response => {
                        if (response.status === 200) {
                         
                          this.cardRows = response.data.content; // Extrair os dados da resposta paginada
                          this.totalPages = response.data.totalPages; // Total de páginas disponíveis
                        }
                      })
                      .catch(error => {
                        // Lida com erros
                        console.error('Erro a', error);
                      }) .finally(() => {
                        // Após o término do download, oculte o diálogo de progresso
                        this.loading = false;
                      });
            },



  } 
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
}

.logo-container {
  text-align: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fade-in 0.2s ease;
}

.modal-box {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 32px 28px;
  width: 360px;
  max-width: 85vw;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: pop-in 0.2s ease;
}

.modal-icon {
  font-size: 42px;
  color: #e1953f;
  margin-bottom: 16px;
}

.modal-message {
  font-size: 18px;
  color: #2c3e50;
  margin: 0 0 24px 0;
  line-height: 1.4;
}

.modal-button {
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.modal-button:hover {
  background-color: #45a049;
}

.modal-button:active {
  transform: scale(0.96);
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes pop-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Em telas touch (tablets/totens), aumenta o modal para facilitar a leitura e o toque */
@media (hover: none), (pointer: coarse) {
  .modal-box {
    width: 480px;
    padding: 44px 36px;
  }

  .modal-icon {
    font-size: 56px;
  }

  .modal-message {
    font-size: 26px;
  }

  .modal-button {
    padding: 18px 42px;
    font-size: 22px;
  }
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.card-item-container {
  min-height: 400px; /* Definir a altura mínima para os cards */
  margin: 10px; /* Adicionar um espaçamento entre os cards */
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size:14px
}
.footer {
  background-color: #254828;
  width: 100vw;
  margin-top: auto;
  margin-left: calc(50% - 50vw);
  padding: 20px 0;
  box-sizing: border-box;
}

.search-input:focus {
  /* Change the border-color to green when the input is focused */
  border-color: #4caf50 !important;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.search-input {
  padding: 15px 18px; /* Padding padrão para navegador desktop */
  font-size: 20px; /* Fonte padrão para navegador desktop */
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 400px; /* Largura padrão para navegador desktop */
  max-width: 70vw;
  /* Add green border-bottom when the input is focused */
  border-bottom: 2px solid transparent;
  transition: border-color 0.1s;
  box-sizing: border-box;
}

.search-input:focus {
  /* Change the border-color to green when the input is focused */
  border-color: #4caf50;
}

.search-icon {
  margin-left: -48px; /* Adjust the value as needed for spacing */
  display: flex;
  align-items: center;
  background-color: #4caf50; /* Green background for the search icon */
  padding: 14px; /* Padding padrão para navegador desktop */
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.search-icon:active {
  transform: scale(0.95);
}

.search-icon svg {
  width: 32px;
  height: 32px;
}

/* Em telas touch (tablets/totens), aumenta o campo de busca para facilitar a digitação */
@media (hover: none), (pointer: coarse) {
  .search-input {
    padding: 24px 22px;
    font-size: 32px;
    border-width: 2px;
    width: 600px;
    max-width: 75vw;
    border-bottom-width: 3px;
  }

  .search-icon {
    margin-left: -64px;
    padding: 20px;
  }

  .search-icon svg {
    width: 40px;
    height: 40px;
  }
}

.loading-indicator {
  font-size: 18px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}


/* Estilize a imagem de carregamento (opcional) */
.loading-indicator img {
  width: 200px;
  height: 200px;
}


/* Add some hover effects to the search icon to indicate interactivity */
.search-icon:hover {
  background-color: #45a049;
}


/* Estilize o texto de paginação */
.pagination-text {
  font-size: 16px;
  font-family: inherit;
  margin: 0 10px; /* Adicione espaçamento horizontal de 10 pixels */
}


</style>




